import { createFileRoute } from '@tanstack/react-router';

import { FavoritePosts } from '#modules/finder/features/posts/components/FavoritePosts';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/discover/posts/_posts/favorite'
)({
  component: FavoritePosts,
  ssr: false,
});
